import type GameDrawWinnerLocal from "~/libs/interfaces/GameDrawWinnerLocal";
import type GameDrawWinnerStrapi from "~/libs/interfaces/GameDrawWinnerStrapi";
import userLocalFactory from "~/libs/factories/UserLocalFactory";
import gameDrawLocalFactory from "~/libs/factories/GameDrawLocalFactory";
import {useTextHelper} from "~/composables/useTextHelper";

const gameDrawWinnerLocalFactory = {
  createGameDrawFromStrapi(gameDrawWinner?: GameDrawWinnerStrapi): GameDrawWinnerLocal | undefined {
    if (!gameDrawWinner) {
      return undefined;
    }

    const sanitizedName = useTextHelper().removeVulgarisms(gameDrawWinner.name)

    return {
      id: gameDrawWinner.id,
      documentId: gameDrawWinner.documentId,

      createdAt: gameDrawWinner.createdAt ? new Date(gameDrawWinner.createdAt) : undefined,
      updatedAt: gameDrawWinner.updatedAt ? new Date(gameDrawWinner.updatedAt) : undefined,
      publishedAt: gameDrawWinner.publishedAt ? new Date(gameDrawWinner.publishedAt) : undefined,

      userWinningPsc: gameDrawWinner.userWinningPsc,
      winPickupDatetime: gameDrawWinner.winPickupDatetime ? new Date(gameDrawWinner.winPickupDatetime) : undefined,
      prize: gameDrawWinner.prize || 0,

      name: sanitizedName,
      street: gameDrawWinner.street,
      city: gameDrawWinner.city,
      psc: gameDrawWinner.psc,
      phone: gameDrawWinner.phone,
      bankAccountNumber: gameDrawWinner.bankAccountNumber,

      game_draw: gameDrawLocalFactory.createGameDrawFromStrapi(gameDrawWinner.game_draw),
      user: userLocalFactory.createUserFromStrapi(gameDrawWinner.user),
      region: gameDrawWinner.region
    }
  }
}
export default gameDrawWinnerLocalFactory